import {Component, Input} from "@angular/core";
import {FormControl} from "@angular/forms";
import {TranslateService} from "@ngx-translate/core";
import {YesNoComponent} from "@app/shared/components/YesNo/yes-no.component";

@Component({
  selector: 'yes-no-validation',
  templateUrl: './yes-no-validation.component.html'
})
export class YesNoValidationComponent{

  @Input()
  yesNo:YesNoComponent;

  constructor(private translate:TranslateService){

  }

  getMessage(){
    if(this.yesNo && this.yesNo.touched && this.yesNo.enabled){
      if(this.yesNo.value == null){
        return this.translate.instant("common.form.error-required")
      }
    }
    return "";
  }

  touched(){
    return this.yesNo.touched;
  }

}
